const DRAFT_PREFIX = 'clinical-history-draft:v1:';

const storageKey = (dni) => `${DRAFT_PREFIX}${String(dni)}`;

export const loadClinicalHistoryDraft = (dni, storage = window.localStorage) => {
  try {
    const raw = storage.getItem(storageKey(dni));
    if (!raw) return null;
    const draft = JSON.parse(raw);
    if (!draft || typeof draft.formData !== 'object' || !Array.isArray(draft.dirtyFields)) {
      return null;
    }
    return draft;
  } catch (error) {
    return null;
  }
};

export const saveClinicalHistoryDraft = (
  dni,
  formData,
  dirtyFields,
  storage = window.localStorage
) => {
  try {
    storage.setItem(storageKey(dni), JSON.stringify({
      formData,
      dirtyFields: [...new Set(dirtyFields)],
      savedLocallyAt: new Date().toISOString(),
    }));
    return true;
  } catch (error) {
    return false;
  }
};

export const clearClinicalHistoryDraft = (dni, storage = window.localStorage) => {
  try {
    storage.removeItem(storageKey(dni));
  } catch (error) {
    // El guardado remoto ya se completo; un storage bloqueado no debe hacer
    // fallar la interfaz.
  }
};

export const mergeClinicalHistoryDraft = (serverData, draft) => {
  if (!draft) return serverData;
  const restored = { ...serverData };
  draft.dirtyFields.forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(draft.formData, field)) {
      restored[field] = draft.formData[field];
    }
  });
  return restored;
};

export const moveClinicalHistoryDraft = (
  oldDni,
  newDni,
  formData,
  dirtyFields,
  storage = window.localStorage
) => {
  if (String(oldDni) === String(newDni)) return;
  saveClinicalHistoryDraft(newDni, formData, dirtyFields, storage);
  clearClinicalHistoryDraft(oldDni, storage);
};
